/* @ngInject */
function AuditController ($rootScope, $scope, $state, $translate) {
  const api = {}
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.goToPage = (name, options) => {
    $state.go(name, options)
  }

  $scope.isCurrentPage = (name) => {
    return $state.current.name === name
  }
}

export { AuditController }
